var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cpage-meta ng-if=\"vm.loanRequest\" state=\"{{ vm.loanRequest.purpose }}\" document=\"Loan request #{{ vm.loanRequest.reference }}\"\u003E\u003C\u002Fpage-meta\u003E\u003Cpage-meta ng-if=\"vm.loanRequest.businessProfile\" title=\"#{{ vm.loanRequest.reference }}: {{ vm.loanRequest.purpose }}\" description=\"{{ vm.loanRequest.businessProfile.description }}\" image=\"{{ vm.loanRequest.businessProfile.image }}\"\u003E\u003C\u002Fpage-meta\u003E\u003Cdiv class=\"md-padding\"\u003E\u003Chelp-box ng-if=\"vm.loanRequest.status === 'fulfilled'\" heading=\"{{ vm.loanRequest.borrowerDetails.sector }}, {{ vm.loanRequest.borrowerDetails.region }}\"\u003E\u003Cp\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E Warning: the information on this page was current at {{ vm.loanRequest.auction.endDate | date }}. \nBorrowers' circumstances may vary over the period of a loan.\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003Ch2 ng-if=\"vm.loanRequest.status != 'fulfilled'\"\u003E{{ vm.loanRequest.borrowerDetails.sector }}, {{ vm.loanRequest.borrowerDetails.region }}\u003C\u002Fh2\u003E\u003Cdiv layout=\"row\" layout-wrap layout-align=\"center start\"\u003E\u003Cimg src=\"{{ vm.loanRequest.businessProfile.image }}\"\u003E\u003Cdiv class=\"text-panel\" flex\u003E\u003Ch3\u003E{{ vm.loanHeading }}\u003Csup ng-if=\"vm.isTruePillarsLoan\"\u003E*\u003C\u002Fsup\u003E\u003C\u002Fh3\u003E\u003Cp ng-bind-html=\"vm.loanRequest.businessProfile.description\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chelp-box ng-if=\"vm.loanRequest.businessProfile.notes\"\u003E\u003Cp ng-bind-html=\"vm.loanRequest.businessProfile.notes\"\u003E\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003Csection class=\"fine\" ng-if=\"vm.isTruePillarsLoan\"\u003E\u003Cp\u003E* This statement has been provided by the borrower to introduce their business and describe how they\nplan to use the loan. The photo is also supplied by the borrower but may not be of the business itself.\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;